import { createContext, useContext, useState } from "react";
import { getLocalStorage } from "../Functions/Utils";

const StoreContext = createContext();

const GlobalStateProvider = ({ children }) => {
    const [user_Roll, setUser_Roll] = useState(getLocalStorage("user_roll"));
    const [menuList, setMenuList] = useState(JSON.parse(getLocalStorage("menuList")));
    const [user, setUser] = useState(getLocalStorage('user'))
    const [uploadSide, setUploadSide] = useState(true)
    const [uploadedFile, setUploadedFile] = useState(null)
    // const addStoreDetails = details => {
    //     // setStoreDetails({...storeDetails, ...details});
    //     setUser_Roll(prevState => {
    //       return {...prevState, ...details};
    //     });
    //   };
    return (
        <StoreContext.Provider
            value={{

                user_Roll: user_Roll,
                setUser_Roll: setUser_Roll,
                menuList: menuList,
                setMenuList: setMenuList,
                user: user,
                setUser: setUser,
                uploadSide: uploadSide,
                setUploadSide: setUploadSide,
                uploadedFile : uploadedFile,
                setUploadedFile: setUploadedFile
            }}>
            {children}
        </StoreContext.Provider>
    )
}
export const useStoreValues = () => useContext(StoreContext);

export default GlobalStateProvider;